import React,{useState,useEffect} from 'react';
import { Container, Row, Col, Card, Spinner, Alert, Badge } from 'react-bootstrap';
import { makeGetRequest } from '../services/httpHelper';
import ErrorHandler from '../services/ErrorHandler';
import { FaHandsHelping, FaMapMarkerAlt, FaCalendarAlt, FaBullhorn } from 'react-icons/fa';
import { IMAGE_BASE_URL } from '../constants/paths';
import { Helmet } from "react-helmet-async";

const CommunityEngagements = () => {
  const church = JSON.parse(localStorage.getItem('church'));
  const [engagements, setEngagements] = useState([]);
  const [missions, setMissiones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const getMissions = async () => {
    setIsLoading(true);
    const res = await makeGetRequest(`missions/${church.id}`);
    if (res && res.errorType) {
      const errorMessage = ErrorHandler(res);
      setError(errorMessage);
    } else {
      setMissiones(res.data);
    }
    setIsLoading(false);
  };

  const getCommunityEngagements = async () => {
    setIsLoading(true);
    const res = await makeGetRequest(`community-engagements/${church.id}`);
    if (res && res.errorType) {
      const errorMessage = ErrorHandler(res);
      setError(errorMessage);
    } else {
      setEngagements(res.data);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getMissions();
    getCommunityEngagements();
  }, []);

  const metaDesc = `${church.church_name} community engagements`;

  return (
    <>
      <Helmet>
        <title>Our Engagements</title>
        <meta name="description" content={metaDesc} />
        <link rel='canonical' href='/community-engagements' />
      </Helmet>

      <Container className="py-4">
        {error && <Alert variant="danger">{error}</Alert>}
        {isLoading ? (
          <div className="text-center my-5">
            <Spinner animation="border" variant="primary" />
            <p className="mt-3">Loading engagements...</p>
          </div>
        ) : (
          <>
            {missions.length > 0 && <h3 className="mb-4 text-primary">Missions</h3>}
            <Row className="mb-5">
              {missions.map((mission, index) => (
                <Col key={index} xs={12} md={6} lg={4} className="d-flex align-items-stretch">
                  <Card className="mb-4 shadow-sm w-100">
                    <Card.Body>
                      <div className="mb-2 text-center">
                        <FaHandsHelping size={32} className="text-success" />
                      </div>
                      <Card.Title className="text-center text-dark fw-bold">{mission.title}</Card.Title>
                      <Card.Text>{mission.description}</Card.Text>
                      <Card.Text><FaMapMarkerAlt className="me-2 text-muted" />{mission.location}</Card.Text>
                      <Card.Text><FaCalendarAlt className="me-2 text-muted" />{mission.date}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>

            {engagements.length > 0 && <h3 className="mb-4 text-primary">Community Engagements</h3>}
            <Row>
              {engagements.map((engagement, index) => (
                <Col key={index} xs={12} md={6} lg={4} className="d-flex align-items-stretch">
                  <Card className="mb-4 shadow-sm w-100">
                    <Card.Img
                      variant="top"
                      crossOrigin="anonymous"
                      src={IMAGE_BASE_URL + engagement.photo}
                      style={{ height: '200px', objectFit: 'cover' }}
                    />
                    <Card.Body>
                      <div className="mb-2 text-center">
                        <FaBullhorn size={30} className="text-info" />
                      </div>
                      <Card.Title className="text-center text-dark fw-bold">{engagement.activity}</Card.Title>
                      <Card.Text>{engagement.description}</Card.Text>
                      <Card.Text><FaCalendarAlt className="me-2 text-muted" />{engagement.date}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        )}
      </Container>
    </>
  );
};

export default CommunityEngagements;
